<template>
    <div class="landing-outer">
        <div></div>
        <div class="landing-inner">
            <div class="backdrop">
                <img src="@/assets/blue-green-background-capsule.webp" alt="DBG Background" style="width: 100%" />
            </div>
            <div class="scroll-container" :style="{color: themeColors.colorWhite}">
               <div>An authentication error has occurred: {{authStore.authErrorDescription}}</div>
            </div>
        </div>
        <div class="dbg-divisions-logos">
            <ArrotexLogo width="165px" height="50px" :fill="themeColors.colorMute" />
            <VidacorpLogo width="165px" height="50px" :fill="themeColors.colorMute" />
            <IpaLogo :width="160" :height="85" :fill="themeColors.colorMute" />
            <AxeLogo width="95px" height="50px" :fill="themeColors.colorMute" />
        </div>
    </div>
</template>

<script setup lang="ts">
import ArrotexLogo from '@/components/icons/ArrotexLogo.vue'
import VidacorpLogo from '@/components/icons/VidacorpLogo.vue'
import AxeLogo from '@/components/icons/AxeLogo.vue'
import IpaLogo from '@/components/icons/IpaLogo.vue'

import {useAuthStore, useThemeStore} from '@/stores'

const authStore = useAuthStore();
const themeStore = useThemeStore();
const { themeColors } = themeStore;

</script>

<style scoped>
.landing-outer {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    padding: 1% 5%;
}

.landing-inner {
    position: relative;
}

.landing-inner .backdrop {
    position: absolute;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    /* background-image: linear-gradient(to right, var(--color-arrotex-3), var(--color-vidacorp-3)); */
    border-radius: 2500px;
    position: relative;
    width: clamp(800px, 87.5vw, 3000px);
    aspect-ratio: 50 / 23;
}

.landing-inner .scroll-container {
    position: absolute;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    top: 0;
    overflow-x: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.landing-inner .scroll-container::-webkit-scrollbar {
    display: none;
}

.landing-inner:after {
    content: '';
    width: 30%;
    aspect-ratio: 1.25;
    background-color: var(--color-arrotex-3);
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: -1;
    border-radius: 50%;
    filter: blur(40px);
    opacity: 0.75;
}

.landing-inner:before {
    content: '';
    width: 30%;
    aspect-ratio: 1;
    background-color: var(--color-vidacorp-3);
    position: absolute;
    top: 0;
    right: 0;
    z-index: -1;
    border-radius: 50%;
    filter: blur(40px);
    opacity: 0.75;
}

.dbg-divisions-logos {
    display: flex;
    align-items: center;
    height: 10%;
    justify-content: space-around;
    width: 60%;
}

</style>
